<template lang="pug">
  .shopify
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    .contain-layout(v-else)

      .main-layout(v-if="!action")
        v-container(style="max-width:600px").px-7
          v-layout.my-4.mx-4
            v-row.fill-height.ma-0(align='center' justify='center' @click="action = null" style="cursor: pointer;")
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/shopify_logo.png')" style="width:140px" contain)
          v-btn.mt-8.button-AA-medium.white--text.info500(block depressed @click="openSetup") {{ $t('connect_website') }}
            v-icon(v-if="permission" right color="green lighten-1") mdi-check-circle
          v-btn.button-AA-medium.white--text.info500(depressed v-if="permission" block outlined @click="openSyncProducts") {{ $t('sync_products') }}
      .action-layout(v-else)
        v-layout.mb-14.mt-2.mx-4
          div.mr-4
            v-icon(left color="black" :size="20" @click="action = null") mdi-arrow-left
          div.h6.mt-1 {{ $t('shopify_setup') }}
        setup-shopify(v-if="action == 'setup-account'" :company="company" :ecommerce.sync="ecommerce")
        //SyncShopifyProducts(v-if="action == 'sync-products'" :ecommerce.sync="ecommerce")

</template>

<script>
import { mapActions } from 'vuex'
import SetupShopify from '@/views/admin/settings/SetupShopify.vue'
import SyncShopifyProducts from '@/views/admin/settings/SyncShopifyProducts.vue'

export default {
  name: 'Shopify',
  components: { SetupShopify, SyncShopifyProducts },
  props: ['company'],
  data: () => ({
    isFetching: true,
    ecommerce: {},
    action: null,
    permission: false
  }),
  mounted () {
    this.fetchEcommerce()
    if (this.$route.hash === '#setup') {
      this.action = 'setup-account'
    } else if (this.$route.hash === '#syncproducts') {
      this.action = 'sync-products'
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    gotoActivate () {
      this.$router.push('/admin/settings')
    },
    fetchEcommerce () {
      this.$axios.get(`/ecommerce/shopify/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length > 0) {
          this.ecommerce = {...response.data.results[0]}
          this.checkPermission(this.ecommerce.id)
        }
        this.isFetching = false
      }).catch(() => {})
    },
    checkPermission (val) {
      this.axios.get(`/ecommerce/shopify/${val}/permissions`)
      .then(resp => {
        if (resp.status === 200) {
          let check = resp.data.filter(f => f.status === false)
          if (check.length === 0) {
            this.permission = true
          }
        }
      }).catch(() => {})
    },
    openSetup () {
      
      this.action = 'setup-account'
      let route = { ...this.$route }
      route.hash = '#setup'
      this.$router.replace(route)
    },
    openSettings () {
      this.action = 'settings'
      let route = { ...this.$route }
      route.hash = '#settings'
      this.$router.replace(route)
    },
    openSyncProducts () {
      // this.action = 'sync-products'
      // let route = { ...this.$route }
      // route.hash = '#syncproducts'
      this.$router.push('/admin/settings/shopify/products')
    }
  }
}
</script>

<i18n>
{
  "en": {
    "shopify_setup": "Shopify Setup"
  },
  "id": {
    "shopify_setup": "Pengaturan Shopify"
  }
}
</i18n>
